import { render } from "./homePrivate.vue?vue&type=template&id=034c7fb8&scoped=true"
import script from "./homePrivate.vue?vue&type=script&lang=js"
export * from "./homePrivate.vue?vue&type=script&lang=js"

import "./homePrivate.vue?vue&type=style&index=0&id=034c7fb8&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034c7fb8"]])

export default __exports__